// removed by extract-text-webpack-plugin
module.exports = {"container":"_1E52GT_xvqOMj_YRkbYLle","pending":"_27tjKXTkO62TmUvbmnqDOH"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Document/Page/Field/Show/Checkbox/styles.css
// module id = 2922
// module chunks = 0